import React from "react";
import { catalogLink } from "../../../config/app";
import Feed from '../../elements/icons/Feed';
import { NavLink } from "react-router-dom";

export default class BrowseCatalogButton extends React.PureComponent {
    render() {

        return (
            <div>
                <NavLink className={'browse-catalog-button'} to={catalogLink}>
                    <Feed/>

                    <div className={'link-text'}>
                        Browse the catalog
                    </div>
                </NavLink>
            </div>
        );
    }
}
